











import Vue from "vue";
export default Vue.extend({
  props: {
    titre: {
      type: String,
      default: "Aucun titre",
    },
    customStyleTitreFicheInd: {
      type: Object,
      default: () => ({
        color: "#663682",
        textAlign: "center",
      }),
    },
    TitleSeparateur:{
      type:Boolean,
      default:false
    }
  },
  computed:{
    getCustomStyleTitreFicheInd(){
      return this.customStyleTitreFicheInd ? this.customStyleTitreFicheInd : null;
    }
  }
});
